import AdapterError from '@ember-data/adapter/error';

export default class TryAgainError extends AdapterError {
  message = 'try-again';
  declare status: number;
}
